import React, { Component } from 'react';
import { browserHistory } from 'react-router';

import DetailView from '../Common/DetailView';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import ErrorSnackbar from '../Common/ErrorSnackbar';
import EventWrapper from './EventWrapper';
import EventDialog from './EventDialog';
import EventDialogCreate from '../Event/EventDialogCreate';

import CalendarIcon from 'material-ui/svg-icons/action/date-range';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import ListIcon from 'material-ui/svg-icons/action/list';

import buildContextMenu from '../Common/BuildContextMenu';
import { getISODateLimits as getDateLimits } from '../../utils/Date';
import EventActions from '../../actions/EventActionCreator';
import EventStore from '../../stores/EventStore';
import { statusColours } from '../../constants/ColourConstants';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { DateStyles } from '../../constants/CentricConstants';

const localizer = BigCalendar.momentLocalizer(moment);

const style = {
    icon: {
        height: '32px',
        width: '32px',
    }
};

const getMenuItems = () => [
    {
        link: `/dashboard/events`,
        icon: <ListIcon />,
        label: 'List View'
    },
    {
        type: 'divider'
    },
    {
        link: '/logout',
        icon: <CancelIcon />,
        label: 'Sign out',
    },
];

class EventCalendar extends Component {
    constructor() {
        super(...arguments);
        this.eventChange = this.eventChange.bind(this);
        this.convertEvent = this.convertEvent.bind(this);
        this.createEvent = this.createEvent.bind(this);
        this.openNewEventDialog = this.openNewEventDialog.bind(this);
        this.actions = buildContextMenu(getMenuItems());
        this.state = { events: [], newEventDialog: {} };
    }

    componentWillMount() {
        this.eventChange();
    }

    componentDidMount() {
        this.eventListener = EventStore.addListener(this.eventChange);
        EventActions.getAll({...getDateLimits(new Date(), 'month'), limit: 0, withDelegateCount: true, withTrainers: true});
    }

    componentWillUnmount() {
        this.eventListener.remove();
    }

    render() {
        const scrollToTime = new Date();
        scrollToTime.setHours(6);
        return (
            <DetailView
                title=""
                backButton={true}
                actions={this.actions}
            >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader
                            title="Calendar"
                            subtitle="Events"
                            avatar={(<CalendarIcon style={style.icon} color={statusColours.default} />)}
                        />
                        <CardText className="cent-card-calendar">
                            <BigCalendar
                                localizer={localizer}
                                popupOffset={20}
                                views={[ 'month', 'week', 'day' ]}
                                selectable
                                defaultView="month"
                                events={this.state.events}
                                eventPropGetter={eventPropGetter}
                                onSelectEvent={({url}) => !!url && browserHistory.push(url)}
                                onNavigate={(date, view) => EventActions.getAll({...getDateLimits(date, view), limit: 0, withDelegateCount: true, withTrainers: true})}
                                components={{eventWrapper: EventWrapper}}
                                onSelectSlot={this.openNewEventDialog}
                                scrollToTime={scrollToTime}
                            />
                        </CardText>
                    </Card>
                </div>
                <ErrorSnackbar/>
                <EventDialog
                    event={this.state.selectedEvent}
                    onClose={() => this.selectEvent()}
                    editLink={(this.state.selectedEvent && !!this.state.selectedEvent.canEdit && `/dashboard/event/${this.state.selectedEvent.id}/edit`) || null}
                />
                { this.state.newEventDialog.open && (
                    <EventDialogCreate
                        open
                        nameRequired
                        title="New Event"
                        start={this.state.newEventDialog.start}
                        end={this.state.newEventDialog.end}
                        eventDates={this.state.newEventDialog.eventDates}
                        onSave={this.createEvent}
                        onClose={() => this.setState({newEventDialog: {open: false}})}
                    />
                )}
            </DetailView>
        );
    }

    eventChange() {
        const events = EventStore.getByType('event');
        if (!!events) {
            this.setState({events: events.map(this.convertEvent)});
        }
    }

    selectEvent(eventId) {
        this.setState({ selectedEvent: (!!eventId && EventStore.getById(eventId)) || null });
    }

    convertEvent({id, name, ...event}) {
        const start = new Date(event.eventStart || event.timeStart);
        const end = new Date(event.eventEnd || event.timeEnd);
        return {
            id,
            title: name,
            start,
            end,
            allDay: (start.toLocaleTimeString() === "00:00:00" && end.toLocaleTimeString() === "00:00:00"),
            url:   `/dashboard/event/${id}`,
            selectAction: () => this.selectEvent(id)
        };
    }

    createEvent(data) {
        data.timeStart = data.timeStart.toString().replace(/\s\([^)]+\)/, '');
        data.timeEnd = data.timeEnd.toString().replace(/\s\([^)]+\)/, '');
        data.description = '';
        data.periodic = false;
        data.visibility = data.private ? 'private' : 'public';

        EventActions.save(data);
        this.setState({newEventDialog: {open: false}});
    }

    openNewEventDialog({start, end}) {
        const startDate = start.toLocaleString('en-GB', DateStyles.shortWeekday);
        const endDate = end.toLocaleString('en-GB', DateStyles.shortWeekday);

        this.setState({
            newEventDialog: {
                start,
                end,
                open: true,
                eventDates: startDate === endDate ? startDate : `${startDate} - ${endDate}`
            }
        });
    }
}

const eventPropGetter = (event, startDate, endDate, selected) => {
    let prop = {};
    const now = (new Date()).getTime();
    if (endDate.getTime() < now) {
        prop.className = 'cent-event-past';
    } else if (startDate.getTime() > now) {
        prop.className = 'cent-event';
    }
    return prop;
};

export default EventCalendar;
